module.exports = __webpack_public_path__ + "img/error.b3bd0483.png";